module.exports = __webpack_public_path__ + "src/assets/textures/petri/alcohol_spray_lambert1_AO.jpg";